<template>
    <v-container style="max-width:100vw;">
        <!-- Filtros -->
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterExpense @filtersExpense="filtersExpense"/>
        </v-navigation-drawer>
        <!-- Contenedor -->
        <v-data-table :headers="headers" :items="expenses" :options.sync="options" class="elevation-0 px-6 py-4">
            <!-- Header -->
            <template v-slot:top>
                <v-toolbar flat >
                    <v-toolbar-title>Gastos</v-toolbar-title>
                    <v-btn icon>
                        <v-icon @click="openFilter">mdi-filter</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-menu bottom left offset-y v-show="permissions('download')">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" :loading="exporting">
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="exportExcel(false)">
                                Lo que se ve en pantalla
                            </v-list-item>
                            <v-list-item @click="exportExcel(true)">
                                Todo
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </template>

            <template v-slot:[`item.amount`]="{ item }">
                {{ (item.amount*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }} 
            </template>


            <template v-slot:[`item.paid`]="{ item }">
                 <v-icon @click="pagar(item.id,0)" v-if="(item.paid)" color="green"> mdi-check </v-icon>
                <v-icon @click="pagar(item.id,1)" v-else color="red"> mdi-close </v-icon>
            </template >


            <!-- Footer -->
            <template v-slot:footer>
                <v-container style="margin-bottom:-80px!important;">
                    <v-select :items="sumavg" v-model="totalType" style="width: 100px; display: inline-block; margin-right:30px; font-size: 14px;"></v-select>
                    <v-select :items="campos" v-model="campo" item-text="text" item-value="value" style="width: 100px; display: inline-block; margin-right:30px; font-size: 14px;"></v-select>
                    <strong v-if="totalType=='sum'">Total = {{ sumField(campo) }}</strong>
                    <strong v-if="totalType=='avg'">Promedio = {{ avgField(campo) }}</strong>
                </v-container>
            </template> 




            <!-- Acciones por fila -->
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left v-if="permissions('editExpenses')==true || permissions('deleteExpenses')==true">
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>
                    <v-list style="font-size:13px;">
                        <v-list-item @click="editItem(item)" v-show="permissions('editExpenses')">
                            <v-icon small class="mr-2">
                                mdi-pencil
                            </v-icon>
                            Editar
                        </v-list-item>
                        <v-list-item @click="deleteItem(item)" v-show="permissions('deleteExpenses')">
                            <v-icon small class="mr-2">
                                mdi-delete
                            </v-icon>
                            Eliminar
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <!-- Creación -->
            <template v-slot:[`item.pdf`]="{ item }">
                <v-btn v-bind:href="liga + 'files/' + item.pdf" target="_blank" icon>
                    <v-icon v-if="item.pdf!=undefined">mdi-download-circle</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`item.payment_invoice`]="{ item }">
                <v-btn v-bind:href="liga + 'files/' + item.payment_invoice" target="_blank" icon>
                    <v-icon v-if="item.payment_invoice!=undefined">mdi-download-circle</v-icon>
                </v-btn>
            </template>
            <!-- Tabla sin información -->
            <template v-slot:no-data>
                No existen registros de gastos aún
            </template>
        </v-data-table>
        <!-- Crear gasto -->
        <v-dialog v-model="createDialog" max-width="900px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e25200" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
          </template>
          <create v-if="createDialog" @closeDialogCreateExpense="closeDialogCreateExpense"/>
        </v-dialog>
        <!-- Editar gasto -->
        <v-dialog v-model="editDialog" max-width="900px">
          <edit v-if="editDialog"  v-bind:editedItem="expense" @closeDialogEditExpense="closeDialogEditExpense"/>
        </v-dialog>
        <!-- Dialogo confirmación -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    ¿Seguro que deseas borrar este gasto?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteExpense()">
                    Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel()">
                    Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <!-- Dialogo confirmación -->
        <div class="text-center">
            <v-bottom-sheet  v-model="sheet2" inset>
                <v-sheet class="text-center" height="120px">
                    <v-row class="pt-6 ma-0 px-12">
                        <v-col class="pt-0" cols="12" sm="6" md="4">
                            <v-autocomplete clearable v-model="editedItem.payment_method_id" :items="methodList" label="Metodo de Pago" item-text="method" item-value="id">
                                <template slot="no-data"><div class="px-4 py-1">No existen metodos relacionados.</div></template>                      
                            </v-autocomplete>
                        </v-col>
                        <v-col class="pt-0" cols="12" sm="6" md="4">
                            <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                <template v-slot:activator="{ on }">
                                    <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="editedItem.payment_date" label="Fecha de Pago" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker color="primary" v-model="editedItem.payment_date" @input="datePicker = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col class="pt-0" cols="12" sm="6" md="3">
                            <v-file-input
                                v-model="payment_invoice"
                                label="Comprobante de Pago"
                                :loading="uploading"
                                outlined 
                            ></v-file-input>
                        </v-col>
                        <v-col class="pt-0" cols="12" sm="6" md="1">
                            <v-btn color="blue darken-1" class="mt-4" text @click="payExpense()" :loading="gris" :disabled="gris || uploading || editedItem.payment_date==undefined||editedItem.payment_date==null||editedItem.payment_date==''||editedItem.payment_method_id==undefined||editedItem.payment_method_id==null||editedItem.payment_method_id==''">Guardar</v-btn>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-bottom-sheet>
        </div>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from "axios";
import FilterExpense from "../expenses/filter"
import Create from "../expenses/create"
import Edit from "../expenses/edit"
export default {
    components: {
        'filterExpense':FilterExpense,
        'create':Create,
        'edit':Edit,
    }, 
    data: () => ({
        uploading:false,
        payment_invoice:'',
        gris:false,
        campo:'amount',
        campos:[
            { text: 'Monto', value: 'amount' },
        ],
        totalType:'sum',
        sumavg:['sum', 'avg'],
        expense:'',
        sheet: false,
        sheet2: false,
        datePicker:false,
        filters: false,
        exporting:false,
        editDialog: false,
        createDialog: false,
        deleteId:'',
        options: {
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
        },
        expenses: '',
        filtersApplied: false,
        lastFilters: null,
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        editedItem:'',
    }),
    computed: {
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user;
            }
        },
        headers(){ 
            return [
            { text: 'Concepto', value: 'concept' },
            { text: 'Tipo de Gasto', value: 'type' },
            { text: 'Proveedor', value: 'provider_id' },
            { text: 'Serie', value: 'serie' },
            { text: 'Metodo de Pago', value: 'payment_method_id' },
            { text: 'Monto', value: 'amount' },
            { text: 'Fecha', value: 'date' },
            { text: 'Factura', value: 'invoice' },
            { text: 'Vencimiento', value: 'due_date' },
            { text: 'Pago', value: 'payment_date' },
            { text: 'Pagada', value: 'paid' },
            { text: 'Comprobante de Pago', value: 'payment_invoice' },
            { text: 'Notas', value: 'notes' },
            { text: 'PDF', value: 'pdf' },
            { text: 'Creación', value: 'created_at' },
            { text: 'Creador', value: 'created_by_user_id' },
            { text: 'Edición', value: 'updated_at' },
            { text: 'Editor', value: 'last_updated_by_user_id' },
            { value: 'actions', sortable: false, align: 'end', },
        ]},
        expensesLists(){
            return this.$store.state.expense.expenses.map(id=>{
                return{
                    id:id.id,
                    concept: id.concept,
                    type: this.expenseType(id.type),
                    provider_id: this.provider(id.provider_id),
                    serie: id.serie,
                    payment_method_id: this.method(id.payment_method_id),
                    amount: id.amount,//.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    date: id.date,
                    invoice: id.invoice,
                    due_date: id.due_date,
                    payment_date: id.payment_date,
                    paid: id.paid,
                    notes: id.notes,
                    pdf: id.pdf,
                    created_by_user_id: this.salesman(id.created_by_user_id),
                    last_updated_by_user_id: this.salesman(id.last_updated_by_user_id),
                    created_at: id.created_at.slice(0, 10),
                    updated_at: id.updated_at.slice(0, 10),
                    payment_invoice: id.payment_invoice
                }
            });
        },
        methodList:{
            get(){
                return this.$store.state.payment_method.payment_methods
            }
        },
    },
    created () {
        this.$store.dispatch('provider/getProviders')
        this.$store.dispatch('expense/getExpenses')
        this.$store.dispatch('expense_type/getExpenseTypes')
        this.expenses = this.expensesLists   
    },
    watch: {
        payment_invoice(file) {
            this.uploadPaymentInvoice(file);
        },
        '$store.state.expense.expenses': {
            handler() {
                if (this.filtersApplied && this.lastFilters) {
                    this.filtersExpense(this.lastFilters);
                    return;
                }
                this.expenses = this.expensesLists;
            },
            deep: true
        }
    },
    methods: {
        pagar(id, paid){
            const expense = this.$store.state.expense.expenses.find(expense=>expense.id == id)
            if (!expense) return

            this.editedItem = Object.assign({}, expense)
            this.payment_invoice = null

            if (paid === 0) {
                this.editedItem.paid = false
                this.editedItem.last_updated_by_user_id = this.currentUser.id
                axios.put(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/expense/update", Object.assign(this.editedItem)).then(() => {
                    this.$store.dispatch('expense/getExpenses')
                }).catch(error => {
                    this.snackbar = {
                        message: error.response?.data?.message || 'Error al actualizar el gasto',
                        color: 'error',
                        show: true
                    }
                })
                return
            }

            this.sheet2 = true
        },
        sumField(key) {//suma
            // sum data in give key (property)
            var suma=this.expenses.reduce((a, b) => (a*1) + ((b[key]*1) || 0), 0)
            return suma.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})
        },
        avgField(key){//primedio
            var suma=this.expenses.reduce((a, b) => (a*1) + ((b[key]*1) || 0), 0)
            return (suma/this.expenses.length).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})
        },
        salesman(id){
            return this.$store.state.user.users.filter(user=>user.id == id).map(user=>user.name + ' ' + user.last)
        },
        method(id){
            return this.$store.state.payment_method.payment_methods.filter(method=>method.id == id).map(method=>method.method)[0]
        },
        provider(id){
            return this.$store.state.provider.providers.filter(provider=>provider.id == id).map(provider=>provider.name)[0]
        },
        expenseType(id){
            return this.$store.state.expense_type.expense_types.filter(type=>type.id == id).map(type=>type.name)[0]
        },
        lowerCase(text){
            if(text!=null&&text!=undefined&&text!=''){
                return text.toLowerCase()
            }else{
                return ' '
            }
        },
        openFilter(){
            if(this.filters == false){
                this.$emit("closeDrawer", false);
                this.filters = true
            }else{
                this.$emit("closeDrawer", true);
                this.filters = false
            }
        },
        permissions(permission){
        if(this.currentUser.id==1){
          return true
        }else if(this.currentUser.permissions!=undefined){
          if(this.currentUser.permissions.includes(permission)){
            return true
          }else{
            return false
          }
        }else{
          return false
        }
      },
        removeDuplicates(originalArray, prop) {
            var newArray = [];
            var lookupObject  = {};
            for(var i in originalArray) {
                lookupObject[originalArray[i][prop]] = originalArray[i];
            }
            for(i in lookupObject) {
                newArray.push(lookupObject[i]);
            }
            return newArray;
        },
        buildExportParams(all = false) {
            const params = {
                page: all ? 1 : this.options.page,
                itemsPerPage: all ? this.expenses.length : this.options.itemsPerPage,
                export: 1,
            }

            if (Array.isArray(this.options.sortBy) && this.options.sortBy.length === 1) {
                params.sort = `${this.options.sortDesc?.[0] ? '-' : ''}${this.options.sortBy[0]}`
            }

            const filters = this.lastFilters || {}

            if (filters.provider_id?.length) params['filter[provider_id]'] = filters.provider_id.join(',')
            if (filters.type_id?.length) params['filter[type]'] = filters.type_id.join(',')
            if (filters.serie?.length) params['filter[serie]'] = filters.serie.join(',')
            if (filters.payment_method_id?.length) params['filter[payment_method_id]'] = filters.payment_method_id.join(',')
            if (filters.user_id?.length) params['filter[user_id]'] = filters.user_id.join(',')
            if (filters.concept) params['filter[concept]'] = filters.concept
            if (filters.invoice) params['filter[invoice]'] = filters.invoice
            if (filters.description) params['filter[notes]'] = filters.description
            if (filters.pay === true) params['filter[paid]'] = 1
            if (filters.pay === 'perro') params['filter[paid]'] = 0
            if (filters.date?.length === 2) params['filter[date_between]'] = `${filters.date[0]},${filters.date[1]}`
            if (filters.expiration_date?.length === 2) params['filter[due_date_between]'] = `${filters.expiration_date[0]},${filters.expiration_date[1]}`
            if (filters.pay_date?.length === 2) params['filter[payment_date_between]'] = `${filters.pay_date[0]},${filters.pay_date[1]}`

            return params
        },
        getExportFilename(response) {
            const disposition = response.headers?.["content-disposition"] || "";
            const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            if (match && match[1]) {
                return match[1].replace(/['"]/g, "");
            }
            return `expenses_${new Date().toISOString().slice(0, 10)}.xlsx`;
        },
        downloadFile(blobData, filename) {
            const url = window.URL.createObjectURL(new Blob([blobData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        },
        filtersExpense: function(params) {
            this.filtersApplied = true
            this.lastFilters = params
            this.expenses = ''
            var filterExpense = this.$store.state.expense.expenses

            if(params.user_id!=''&&params.user_id!=undefined&&params.user_id!=null){
                var uno = filterExpense.filter(expense=>expense.user_id == params.user_id[0])
                for(let i=1; i<params.user_id.length; i++){
                    uno=uno.concat(filterExpense.filter(expense=>expense.user_id == params.user_id[i]))   
                }
                filterExpense = this.removeDuplicates(uno, "id");
            }
            if(params.pay!=''&&params.pay!=undefined&&params.pay!=null){
                filterExpense = filterExpense.filter(expense=>this.sino(expense.paid, params.pay))
            }
            if(params.type_id!=''&&params.type_id!=undefined&&params.type_id!=null){
                var dos = filterExpense.filter(expense=>expense.type == params.type_id[0])
                for(let i=1; i<params.type_id.length; i++){
                    dos=dos.concat(filterExpense.filter(expense=>expense.type == params.type_id[i]))   
                }
                filterExpense = this.removeDuplicates(dos, "id");
            }
            if(params.provider_id!=''&&params.provider_id!=undefined&&params.provider_id!=null){
                var tres = filterExpense.filter(expense=>expense.provider_id == params.provider_id[0])
                for(let i=1; i<params.provider_id.length; i++){
                    tres=tres.concat(filterExpense.filter(expense=>expense.provider_id == params.provider_id[i]))   
                }
                filterExpense = this.removeDuplicates(tres, "id");
            }
            if(params.serie!=''&&params.serie!=undefined&&params.serie!=null){
                var cuatro = filterExpense.filter(expense=>expense.serie == params.serie[0])
                for(let i=1; i<params.serie.length; i++){
                    cuatro=cuatro.concat(filterExpense.filter(expense=>expense.serie == params.serie[i]))   
                }
                filterExpense = this.removeDuplicates(cuatro, "id");
            }
            if(params.payment_method_id!=''&&params.payment_method_id!=undefined&&params.payment_method_id!=null){
                var cinco = filterExpense.filter(expense=>expense.payment_method_id == params.payment_method_id[0])
                for(let i=1; i<params.payment_method_id.length; i++){
                    cinco=cinco.concat(filterExpense.filter(expense=>expense.payment_method_id == params.payment_method_id[i]))   
                }
                filterExpense = this.removeDuplicates(cinco, "id");
            }
            if(params.description!=''&&params.description!=undefined&&params.description!=null){
                filterExpense=filterExpense.filter(expense=>this.lowerCase(expense.notes).includes(params.description.toLowerCase()))
            }

            if(params.concept!=''&&params.concept!=undefined&&params.concept!=null){
                filterExpense=filterExpense.filter(expense=>this.lowerCase(expense.concept).includes(params.concept.toLowerCase()))
            }

            if(params.invoice!=''&&params.invoice!=undefined&&params.invoice!=null){
                filterExpense=filterExpense.filter(expense=>this.lowerCase(expense.invoice).includes(params.invoice.toLowerCase()))
            }

            if(params.date.length>0){
                filterExpense=filterExpense.filter(expense=>((new Date(expense.date) <= new Date(params.date[1])) && (new Date(expense.date) >= new Date(params.date[0]))))
            }
            if(params.expiration_date.length>0){
                filterExpense=filterExpense.filter(expense=>((new Date(expense.due_date) <= new Date(params.expiration_date[1])) && (new Date(expense.due_date) >= new Date(params.expiration_date[0]))))
            }
            if(params.pay_date.length>0){
                filterExpense=filterExpense.filter(expense=>((new Date(expense.payment_date) <= new Date(params.pay_date[1])) && (new Date(expense.payment_date) >= new Date(params.pay_date[0]))))
            }


    
            this.expenses = filterExpense.map(id=>{
                return{
                    id:id.id,
                    concept: id.concept,
                    type: this.expenseType(id.type),
                    provider_id: this.provider(id.provider_id),
                    serie: id.serie,
                    payment_method_id: this.method(id.payment_method_id),
                    amount: id.amount,//.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                    date: id.date,
                    invoice: id.invoice,
                    due_date: id.due_date,
                    payment_date: id.payment_date,
                    paid: id.paid,
                    notes: id.notes,
                    pdf: id.pdf,
                    created_by_user_id: this.salesman(id.created_by_user_id),
                    last_updated_by_user_id: this.salesman(id.last_updated_by_user_id),
                    created_at: id.created_at.slice(0, 10),
                    updated_at: id.updated_at.slice(0, 10),
                    payment_invoice: id.payment_invoice
                }
            });
        },
        closeDialogEditExpense: function() {
            this.editDialog = false;
            this.$store.dispatch('expense/getExpenses')
        },
        closeDialogCreateExpense: function() {
            this.createDialog = false;
            this.$store.dispatch('expense/getExpenses')
        },
        exportExcel: async function (all = false) {
            this.exporting = true
            try {
                const response = await axios.get(
                    process.env.VUE_APP_BACKEND_ROUTE + "api/v2/expenses",
                    {
                        responseType: 'blob',
                        headers: {
                            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        },
                        params: this.buildExportParams(all)
                    }
                )
                this.downloadFile(response.data, this.getExportFilename(response))
            } finally {
                this.exporting = false
            }
        },
        deleteExpense(){
            axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/expense/delete/"+this.deleteId).then(() => {
                this.deleteId = ''
                this.sheet = false
                this.$store.dispatch('expense/getExpenses')
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            });
        },
        uploadPaymentInvoice(file) {
            if (!file) return

            let formData = new FormData();
            formData.append('file', file);
            this.uploading = true

            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/files",
                formData,
                {headers: {"Content-Type": "multipart/form-data"}}
            ).then(response=>{
                this.editedItem.payment_invoice = response.data.file
            }).catch(() => {
                this.snackbar = {
                    message: 'Error al cargar el archivo',
                    color: 'error',
                    show: true
                }
                this.payment_invoice = null
            }).finally(() => {
                this.uploading = false
            })
        },
        payExpense(){
            this.editedItem.paid = true
            this.gris = true
            this.editedItem.last_updated_by_user_id = this.currentUser.id
            this.$nextTick(() => {
                axios.put(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/expense/update",Object.assign(this.editedItem)).then(() => {
                    this.gris = false
                    this.sheet2 = false
                    this.editedItem = ''
                    this.payment_invoice = ''
                    this.$store.dispatch('expense/getExpenses')
                }).catch(error => {
                    this.snackbar = {
                        message: error.response?.data?.message || 'Error al actualizar el gasto',
                        color: 'error',
                        show: true
                    }
                    this.gris = false
                })
            })
        },
        cancel(){
            this.deleteId = ''
            this.sheet = false
        },
        deleteItem (item) {
            this.deleteId = item.id
            this.sheet = true
        },
        editItem(item){
            this.expense = this.$store.state.expense.expenses.filter(expense=>expense.id == item.id)[0]
            this.editDialog = true
        },
        sino(item, param){
            if(param == 'perro'){
                if(item == true){
                    return false
                }else{
                    return true
                }
            }else{
                return (item == param)
            }
        }
    }
}
</script>


<style>
    .bordercolor{
        width: 3px;
        content: ' ';
        height: 47px;
        position: absolute;
        border-radius:5px 0px 0px 5px;
    }
    @media(min-width: 980px){
        .bordercolor{
            margin-top: -13px;
            margin-left: -19px;
        }
    }
    @media(max-width: 980px){
        .bordercolor {
            height: 360px;
            left: 9px;
        }
    }
</style>
